import {
  Box,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';

// Settings for the "Warten" block: amount + unit of the delay.
const WaitSettings = ({ block, readOnly, onConfigChange }) => {
  const config = block.config || {};

  const commitAmount = raw => {
    const parsed = parseInt(raw, 10);
    onConfigChange({ amount: Number.isNaN(parsed) ? 1 : Math.max(1, parsed) });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <FormControl>
        <FormLabel sx={{ typography: 'body2', mb: 1 }}>Wartezeit festlegen</FormLabel>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <TextField
            key={`${block.blockId}-amount`}
            size='small'
            type='number'
            label='Dauer'
            defaultValue={Number(config.amount) || 1}
            disabled={readOnly}
            inputProps={{ min: 1 }}
            onChange={event => commitAmount(event.target.value)}
            sx={{ width: 110 }}
          />
          <FormControl size='small' sx={{ flex: 1 }}>
            <InputLabel id={`fz-wait-unit-${block.blockId}`}>Einheit</InputLabel>
            <Select
              labelId={`fz-wait-unit-${block.blockId}`}
              label='Einheit'
              value={config.unit || 'days'}
              disabled={readOnly}
              onChange={event => onConfigChange({ unit: event.target.value })}
            >
              <MenuItem value='minutes'>Minuten</MenuItem>
              <MenuItem value='hours'>Stunden</MenuItem>
              <MenuItem value='days'>Tage</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </FormControl>
      <Typography variant='caption' color='text.secondary'>
        Nach Ablauf der Wartezeit wird automatisch der nächste verbundene Block ausgeführt.
      </Typography>
    </Box>
  );
};

export default WaitSettings;
